import gql from "graphql-tag";

export default gql`
	query getOrderByID($orderNumber: Int!) {
		getOrderByID(orderNumber: $orderNumber) {
			orderNumber
			firstName
			lastName
			company
			address1
			address2
			address3
			city
			state
			phone
			zip
			country {
				name
			}
			invoiceNumber
			orderDate
			status
			totalCharged
			platformTypes
			salesTaxRate
			balance
			salesTaxAmount
			isSerialNumberGenerationPending
			orderDetails {
				orderDetailID
				qty
				description
				activations
				unitPrice
				plan {
					name
				}
				product {
					name
				}
			}
			subscription {
				allowedActivations
				subscriptionID
				name
				serialNumbers {
					serialNumber
					licenseName
					allowedActivations
					usedActivations
					product {
						description
					}
					code
				}
				allowedOperations {
					viewInvoice
				}
			}
			serialNumbers {
				serialNumber
				licenseName
				allowedActivations
				usedActivations
				product {
					description
				}
				code
			}
			payments {
				id
				amount
				paymentType {
					paymentTypeID
					name
				}
				ccNumber
				ccType
			}
		}
	}
`;

export const readOrderData = ({ data }) => data && data.getOrderByID;
